type NavigateFn = (route: string, params?: Record<string, string>) => void;

export function renderBusinessPending(container: HTMLElement, params: Record<string, string>, navigate: NavigateFn): void {
  const { businessId = '', businessName = 'Your Business' } = params;

  container.innerHTML = `
    <div class="auth-wrap">
      <div class="auth-card" style="text-align:center">
        <div style="font-size:56px;margin-bottom:16px">⏳</div>
        <div class="auth-logo">PREUVU</div>
        <h2 style="font-size:20px;font-weight:700;margin:16px 0 8px">${escHtml(businessName)}</h2>
        <p style="color:var(--text-muted);font-size:13px;line-height:1.7;margin-bottom:24px">
          Your application is <strong style="color:var(--warning)">pending admin review</strong>.<br>
          You'll receive access once an admin approves your account.
        </p>

        <div style="background:var(--bg-primary);border:1px solid var(--border);border-radius:var(--radius-md);padding:14px 18px;margin-bottom:24px;text-align:left">
          <div style="font-size:10px;color:var(--text-muted);font-weight:700;text-transform:uppercase;letter-spacing:1px;margin-bottom:6px">Your Business ID — save this</div>
          <div style="font-family:var(--font-mono);font-size:12px;color:var(--brand-gold);word-break:break-all">${businessId}</div>
        </div>

        <button class="btn btn-ghost" style="width:100%;margin-bottom:10px" id="copy-id-btn">
          Copy Business ID
        </button>
        <button class="btn btn-ghost" style="width:100%" id="back-btn">
          ← Back to Login
        </button>
      </div>
    </div>
  `;

  document.getElementById('copy-id-btn')!.addEventListener('click', () => {
    navigator.clipboard.writeText(businessId).then(() => {
      const btn = document.getElementById('copy-id-btn') as HTMLButtonElement;
      btn.textContent = '✓ Copied!';
      setTimeout(() => { btn.textContent = 'Copy Business ID'; }, 2000);
    });
  });

  document.getElementById('back-btn')!.addEventListener('click', () => navigate('login'));
}

function escHtml(str: string): string {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
